(function () {
  'use strict';
  function init(root) {
    var form = root.closest('form');
    if (!form || form.hpBackorder) return;
    var notice = root.querySelector('[data-hp-backorder-notice]');
    var ack = root.querySelector('[data-hp-backorder-ack]');
    var property = root.querySelector('[data-hp-backorder-property]');
    var error = root.querySelector('[data-hp-backorder-error]');
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-hp-backorder-variants]').textContent); }
    catch (e) { return; }
    var previousId = null;
    var previousQuantity = null;
    var observedInput = null;
    var observer = null;
    var restockStartedAt = Date.now();
    var restockId = null;
    var restockReadyId = null;
    var restockVersion = 0;
    var restockUnsubscribe = null;
    var restockOldEmail = null;
    function subscribeRestock() {
      var api = window.eastsidecoOutOfStock;
      if (restockUnsubscribe || !api || typeof api.onAfterRender !== 'function') return;
      restockUnsubscribe = api.onAfterRender().subscribe(function (event) {
        var current = state();
        if (!event || String(event.selectedVariantID) !== current.id || current.id !== restockId) return;
        var version = restockVersion;
        // Use the app's post-render signal, then allow its queued render to commit.
        window.setTimeout(function () {
          var latest = state();
          var widget = form.nextElementSibling;
          if (version !== restockVersion || latest.id !== restockId || !widget ||
              !widget.matches('[data-hp-restock-alert]')) return;
          var email = widget.querySelector('#esc-oos-form #esc-email-input[name="email"][type="email"]');
          // The app replaces its React root on variant changes. A delayed hook
          // must not make an old variant's still-mounted form actionable.
          if (!email || email === restockOldEmail) return;
          restockReadyId = latest.id;
          updateRestock(latest);
        }, 0);
      });
    }
    function updateRestock(current) {
      var widget = form.nextElementSibling;
      if (!widget || !widget.matches('[data-hp-restock-alert]')) return;
      subscribeRestock();
      if (restockId !== current.id) {
        restockOldEmail = restockId === null ? null : widget.querySelector('#esc-oos-form #esc-email-input[name="email"][type="email"]');
        restockId = current.id;
        restockReadyId = null;
        restockVersion += 1;
        restockStartedAt = Date.now();
      }
      var show = !!(current.variant && current.variant.tracked && Number(current.variant.quantity) <= 0);
      widget.hidden = !show;
      var email = widget.querySelector('#esc-oos-form #esc-email-input[name="email"][type="email"]');
      var nativeForm = widget.querySelector('#esc-oos-form');
      var ready = !!(show && email && restockReadyId === current.id);
      if (nativeForm) { nativeForm.hidden = !ready; nativeForm.inert = !ready; }
      if (!show) { widget.open = false; return; }
      var loading = widget.querySelector('[data-hp-restock-loading]');
      var unavailable = widget.querySelector('[data-hp-restock-unavailable]');
      var failed = !ready && (window.hpRestockLoaderFailed || Date.now() - restockStartedAt > 15000);
      if (loading) loading.hidden = ready || !!failed;
      if (unavailable) unavailable.hidden = !failed;
      if (ready && widget.open && widget.dataset.customerEmail && !widget.dataset.hpRestockPrefilled) {
        // Prefill only the signed-in customer's own empty widget, once; never submit it.
        if (email.value.trim()) { widget.dataset.hpRestockPrefilled = 'true'; return; }
        var descriptor = window.HTMLInputElement && Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
        if (descriptor && descriptor.set) {
          descriptor.set.call(email, widget.dataset.customerEmail);
          email.dispatchEvent(new Event('input', {bubbles:true}));
          widget.dataset.hpRestockPrefilled = 'true';
        }
      }
    }
    function state() {
      var input = form.querySelector('[name="id"]');
      if (input !== observedInput) {
        if (observer) observer.disconnect();
        observedInput = input;
        if (input && window.MutationObserver) {
          observer = new MutationObserver(update);
          observer.observe(input, {attributes:true, attributeFilter:['value','disabled']});
        }
      }
      var variant = variants.find(function (item) { return input && String(item.id) === String(input.value); });
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? String(quantityInput.value) : '1';
      var backorder = !!(variant && variant.tracked && Number(variant.quantity) <= 0 && variant.policy === 'continue');
      var valid = !!(variant && variant.available && input && !input.disabled);
      return {variant:variant, id:input ? String(input.value) : '', quantity:quantity, backorder:backorder, valid:valid};
    }
    function update() {
      var current = state();
      if (current.id !== previousId || current.quantity !== previousQuantity) {
        if (previousId !== null && current.id !== previousId && current.variant) {
          // Shop Circle reads a variant URL parameter before the product form input.
          var url = new URL(window.location.href);
          if (url.searchParams.has('variant') && url.searchParams.get('variant') !== current.id) {
            url.searchParams.set('variant', current.id);
            window.history.replaceState(window.history.state, '', url.toString());
          }
        }
        ack.checked = false;
        error.hidden = true;
        previousId = current.id;
        previousQuantity = current.quantity;
      }
      notice.hidden = !current.backorder;
      ack.disabled = !current.backorder;
      property.disabled = !current.backorder;
      if (!current.backorder) { ack.checked = false; error.hidden = true; }
      if (ack.checked) error.hidden = true;
      updateRestock(current);
      var scope = form.closest('[data-section-type="product-template"]');
      var status = scope && scope.querySelector('.js-product-status');
      if (status) {
        var stock = status.querySelector('.in-stock');
        var label = current.backorder ? 'Backorder — not currently in stock' : (current.valid ? 'Available to order' : 'Sold out');
        if (stock && stock.textContent !== label) stock.textContent = label;
        if (status.getAttribute('data-hp-backorder') !== String(current.backorder)) status.setAttribute('data-hp-backorder', String(current.backorder));
      }
      return current;
    }
    function validate(showError) {
      var current = update();
      var button = form.querySelector('button.btn-add-to-cart');
      var valid = current.valid && !(button && button.disabled) && (!current.backorder || ack.checked);
      if (!valid && current.backorder && !ack.checked && showError) {
        error.hidden = false;
        notice.scrollIntoView({behavior:'smooth',block:'center'});
        ack.focus();
      }
      return valid;
    }
    form.hpBackorder = {update:update,validate:validate};
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('change', function (event) {
      if (event.target.matches && event.target.matches('[name="quantity"]')) {
        ack.checked = false;
      }
      // Existing variant handlers can change the hidden ID during this event.
      Promise.resolve().then(update);
    }, true);
    form.addEventListener('submit', function (event) {
      if (!validate(true)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    form.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('button.btn-add-to-cart, [data-hp-qc-payment]');
      if (target && !validate(true)) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    var restockWidget = form.nextElementSibling;
    if (restockWidget && restockWidget.matches('[data-hp-restock-alert]')) {
      function guardRestock(event) {
        var current = update();
        var nativeForm = event.target.closest && event.target.closest('#esc-oos-form');
        if (nativeForm && (restockReadyId !== current.id || nativeForm.inert)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
      restockWidget.addEventListener('click', guardRestock, true);
      restockWidget.addEventListener('submit', guardRestock, true);
      restockWidget.addEventListener('toggle', update);
    }
    window.addEventListener('pageshow', update);
    var poll = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(poll);
        if (observer) observer.disconnect();
        if (restockUnsubscribe) restockUnsubscribe();
        return;
      }
      update();
    }, 300);
    update();
    form.dispatchEvent(new Event('change', {bubbles:true}));
  }
  document.querySelectorAll('[data-hp-backorder-product]').forEach(init);
})();
